import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { useConfig } from '../../config/ConfigContext';
import Button from '../Button';
import './style.scss';

const unSupportedStates = {
  CT: 'Connecticut',
  WV: 'West Virginia',
  NH: 'New Hampshire',
  VT: 'Vermont',
  KS: 'Kansas',
  MS: 'Mississippi',
  SC: 'South Carolina',
  WA: 'Washington',
  WI: 'Wisconsin',
  WY: 'Wyoming',
  VI: 'Virgin Islands',
  PR: 'Puerto Rico',
  NV: 'Nevada',
};

const Popup = (props) => {
  const appConfig = useConfig();
  const { type, handleAbort, data } = props;
  return (
    <div className="smarty-ui">
      <div className="smarty-popup">
        <div className={cn('smarty-popup-header', type === 1 && 'smarty-popup-missing-input-header')}>
          {type === 1 && 'You didn\'t enter enough information'}
          {type === 2 && 'We Couldn\'t Validate Your Address'}
          {type === 3 && 'P.O. Box address is not allowed'}
          {type === 4 && `Currently we do not accept loan applications for residents of the state of ${unSupportedStates[data.state]}`}
          {type === 5 && 'Did you miss entering your apt/suite/unit number?'}
        </div>
        <div className="smarty-popup-typed-address">
          { type !== 4 && `${data.address || ''} ${data.city || ''} ${data.state || ''} ${data.zipcode || ''}`}
        </div>
        <div className="smarty-choice-alt" style={{ justifyContent: (!appConfig.smartyStreetEnforce && (type !== 1)) ? 'space-between' : 'center' }}>
          { (type !== 1) && <Button title="Use This Address" className="btn btn-primary smarty-choice smarty-choice-abort smarty-abort" onClick={() => { handleAbort(false); }} />}
          <Button title="Edit Address" className="btn btn-outline smarty-choice smarty-choice-abort smarty-abort" onClick={() => handleAbort(true)} />
        </div>
      </div>
    </div>
  );
};

Popup.propTypes = {
  handleAbort: PropTypes.func.isRequired,
  type: PropTypes.number,
  data: PropTypes.object,
};

Popup.defaultProps = {
  type: null,
  data: null,
};

export default Popup;
